module.exports = __webpack_public_path__ + "img/group-15.5b7b72a8.svg";